var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UnPatrolListComponent',{attrs:{"typeName":"定期清掃 未完了一覧","type":3,"settionStrageName":"FixedUnpatrolListStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }